import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      // Client errors are deterministic — retrying them only adds latency.
      retry: (failureCount, error) =>
        error instanceof ApiError && error.status >= 400 && error.status < 500 ? false : failureCount < 1,
    },
    // Actions run even when the browser reports no connection: they fail at once with a clear
    // "not recorded" (§63) instead of waiting silently, and saving on the device (Phase 2D)
    // needs no network at all.
    mutations: { retry: false, networkMode: 'always' },
  },
});
